
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/buero/philosophie",
      function () {
        return require("private-next-pages/buero/philosophie/index.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/buero/philosophie"])
      });
    }
  